import graphqlClient from './graphqlClient';

export interface DesignEditorPreviewSettings {
  includeBackground: boolean;
  includeForeground: boolean;
  firstSpreadOnly: boolean;
  noFlatPreviews: boolean;
  clientSideRendering: boolean;
}

/**
 * Per-product preview settings from the dashboard GraphQL API — the same source the
 * Gelato Create editor uses to decide whether the editor renders previews itself.
 */
const fetchDesignEditorPreviewSettings = async (
  productUid: string,
  hasShutterstockAssets: boolean,
): Promise<DesignEditorPreviewSettings | null> => {
  const operation = 'designEditorPreviewSettings';
  const query = `
    query($productUid: String!, $hasShutterstockAssets: Boolean!) {
      ${operation}(productUid: $productUid, hasShutterstockAssets: $hasShutterstockAssets) {
        includeBackground
        includeForeground
        firstSpreadOnly
        noFlatPreviews
        clientSideRendering
      }
    }
  `;

  const response = await graphqlClient.query<any>(
    { query, variables: { productUid, hasShutterstockAssets } },
    operation,
  );

  return response?.[operation] || null;
};

export default fetchDesignEditorPreviewSettings;
